import { Component } from '@angular/core';

@Component({
  selector: 'app-fee-based',
  templateUrl: './fee-based.component.html',
  styleUrls: ['./fee-based.component.scss']
})
export class FeeBasedComponent {

}
